import React from 'react';

interface DirectorySectionProps {
  title: string;
  icon?: string;
  children: React.ReactNode;
  className?: string;
}

const DirectorySection: React.FC<DirectorySectionProps> = ({
  title,
  icon,
  children,
  className = '',
}) => (
  <section className={`mb-12 ${className}`}>
    <h2 className="text-sm font-semibold uppercase tracking-wide text-[var(--dir-muted)] mb-4 flex items-center gap-2">
      {icon ? <span aria-hidden>{icon}</span> : null}
      {title}
    </h2>
    <div className="rounded-lg border border-[var(--dir-border)] bg-white p-4 sm:p-5">
      {children}
    </div>
  </section>
);

export default DirectorySection;
